var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"cross"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"cross","transform":"translate(1.000000, 0.000000)","stroke":"#000000"},React.createElement("path",{"d":"M0,0 L14,14 L0,0 Z M14,0 L0,14 L14,0 Z","id":"Shape"})))]);
}

Cross.defaultProps = {"width":"16px","height":"14px","viewBox":"0 0 16 14","version":"1.1"};

module.exports = Cross;

Cross.default = Cross;
